<template>
  <div class="mod-account-access">
    <div class="title-page">
      <span class="text-title">账号授权</span>
      <a 
        class="item-btn"
        @click="add"
      >
        + 新增授权账户
      </a>
    </div>
    <ShowForm
      :formData="filterData" 
      :inline="true" 
      type="filter"
      @change="changeHandle"
      @submit="doSearch"
    />
    <ShowTable 
      :listData="listData" 
      :pageSize="params.page_size"
      @linkClick="linkClickHandle" 
      @actionClick="actionClickHandle"
      @pageChange="pageChangeHandle"
      @pageSizeChange="pageSizeChangeHandle"
    />
    <el-dialog 
      :visible.sync="addDialogShow"
      title="新增授权" 
      width="538px"
      top="60px"
      :modal="false"
      :show-close="false"
      custom-class="dialog-right"
    >
      <div class="add-content-box">
        <ShowForm
          ref="form"
          :formData="formData"
          :commitShow="false"
          @action="actionClick"
          @change="formChange"
        />
        <div 
          v-if="(accounts && accounts.length) || noAccountText"
          class="account-box"
        >
          <label class="form-label">账户信息：</label>
          <ul 
            v-if="accounts && accounts.length"  
            class="account-items"
          >
            <li 
              v-for="item in accounts" 
              :key="item.key"
              class="account-item"
            >
              <div class="account-title">{{ accountConfig.title.label }}：{{ item[accountConfig.title.key] }}</div>
              <div class="account-info">
                <div 
                  v-for="c in accountConfig.info"
                  :key="c.key"
                >
                  {{ c.label }}：{{ item[c.key] }}
                </div>
              </div>
            </li>
          </ul>
          <div 
            v-else
            class="no-account-text"
          >
            {{ noAccountText }}
          </div>
        </div>
      </div>
      <div 
        slot="footer" 
        class="dialog-footer"
      >
        <el-button @click="addDialogShow = false">取 消</el-button>
        <el-button 
          type="primary" 
          :loading="addSubmitLoading"
          @click="doAdd"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog 
      :visible.sync="infoDialogShow"
      :title="'账号ID：' + curItem.target_id" 
      width="538px"
      top="60px"
      :modal="false"
      :show-close="false"
      custom-class="dialog-right"
    >
      <ul class="app-items">
        <li class="app-item">
          <label class="app-label">应用ID：</label>
          <span class="app-value">{{ curItem.app_id }}</span>
        </li>
        <li
          v-if="false" 
          class="app-item"
        >
          <label class="app-label">应用秘钥：</label>
          <span class="app-value">{{ secretShow ? curItem.app_secret : pwdString }}</span>
          <a 
            class="btn-item" 
            @click="secretShow=!secretShow"
          >
            {{ secretShow ? '隐藏' : '查看' }}
          </a>
        </li>
        <li class="app-item">
          <label class="app-label">Access Token：<br><span class="app-label-tip">(到期时间：{{ curItem.access_token_expire }})</span></label>
          <span class="app-value">{{ accessShow ? curItem.access_token : pwdString }}</span>
          <a 
            class="btn-item" 
            @click="accessShow=!accessShow"
          >
            {{ accessShow ? '隐藏' : '查看' }}
          </a>
        </li>
        <li class="app-item">
          <label class="app-label">Refresh Token：<br><span class="app-label-tip">({{ curItem.refresh_token_expire }})</span></label>
          <span class="app-value">{{ refreshShow ? curItem.refresh_token : pwdString }}</span>
          <a 
            class="btn-item" 
            @click="refreshShow=!refreshShow"
          >
            {{ refreshShow ? '隐藏' : '查看' }}
          </a>
        </li>
      </ul>
      <div 
        slot="footer" 
        class="dialog-footer"
      >
        <el-button @click="infoDialogShow = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog 
      :visible.sync="cancelDialogShow"
      title="提示"
      width="520px"
      custom-class="dialog-confirm"
    >
      <div class="confirm-content">确认取消授权?</div>
      <div 
        slot="footer" 
        class="dialog-footer"
      >
        <el-button 
          type="primary" 
          @click="cancelAuth"
        >
          确 定
        </el-button>
        <el-button @click="cancelDialogShow = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ShowForm from '@/components/ShowForm/index';
import ShowTable from '@/components/ShowTable/index';
import { formatMap } from '@/assets/js/lib';
import {
  getEnum,
  getAuthList,
  getAppList,
  getAccountList,
  applyAuth,
  cancelAuth,
} from '@/service';

export default {
  components: {
    ShowForm,
    ShowTable,
  },
  data() {
    return {
      filterData: [],
      params: {
        page: 1,
        page_size: 20,
      },
      listData: {
        head: [
          {
            key: 'app_id',
            name: '应用ID',
            fixed: 'left',
            width: '160px',
          },
          {
            key: 'app_name',
            name: '应用名称',
          },
          {
            key: 'auth_type_desc',
            name: '账号类型',
          },
          {
            key: 'target_id',
            name: '账号ID',
            type: 'link',
            disabledKey: 'target_id_disabled',
          },
          {
            key: 'target_name',
            name: '账号名称',
          },
          {
            key: 'apply_time',
            name: '申请时间',
            width: '170px',
          },
          {
            key: 'accept_time',
            name: '授权时间',
            width: '170px',
          },
          {
            key: 'status_desc',
            name: '授权状态',
          },
          {
            key: 'verify_url',
            name: '授权链接',
            type: 'link',
            btnText: '复制链接',
          },
          {
            key: 'action',
            name: '操作',
            type: 'action',
          },
        ],
      },
      addDialogShow: false,
      accountType: [],
      formData: [],
      accountList: [],
      accounts: [],
      accountConfig: {},
      noAccountText: '',
      infoDialogShow: false,
      curItem: {},
      secretShow: false,
      accessShow: false,
      refreshShow: false,
      pwdString: '************************************************',
      cancelDialogShow: false,
      addSubmitLoading: false,
    };
  },
  created() {
    this.getSearchType();
    this.getAccountType();
  },
  methods: {
    async getSearchType() {
      const res = await getEnum({
        enum_type: 'status',
      });
      const options = formatMap(res.data) || [];
      let value = options[0].key;
      this.filterData = [
        {
          key: 'status',
          type: 'select',
          required: true,
          value,
          options,
          valueFormat: Number,
        },
        {
          key: 'keywords',
          placeholder: '支持应用ID/应用名称/账户ID搜索',
        },
      ];
      this.getList();
    },
    async getAccountType() {
      const res = await getEnum({
        enum_type: 'account_type',
      });
      const options = formatMap(res.data) || [];
      this.accountType = options;
    },
    async getList() {
      const res = await getAuthList(this.params);
      let data = res.data || {};
      let list = data.list || [];
      list.forEach((item) => {
        if (Number(item.status) === 2) {
          item.action = [
            {
              key: 'cancel',
              name: '取消授权',
            },
          ];
        } else {
          item.target_id_disabled = true;
        }
      });
      const pageInfo = res.data.page_info || {};
      this.$set(this.listData, 'currentPage', pageInfo.page || 0);
      this.$set(this.listData, 'total', pageInfo.total_number || 0);
      this.$set(this.listData, 'list', list);
    },
    async getAppList() {
      const res = await getAppList({});
      const list = res.data || [];
      const appOptions = formatMap(list, 'id', 'name');

      // 应用增加权限字段(scopes)
      appOptions.forEach((item) => {
        item.scopes = list.find((x) => x.id === item.key).scopes;
      });

      this.formData = [
        {
          key: 'app_id',
          name: '应用名称：',
          type: 'select',
          required: true,
          options: appOptions,
          valueFormat: Number,
        },
        {
          key: 'auth_type',
          name: '账号类型：',
          type: 'select',
          required: true,
          value: this.accountType[0].key,
          options: this.accountType,
          valueFormat: Number,
        },
        {
          key: 'auth_ids',
          name: '授权账号：',
          required: true,
          multiple: true,
          filterable: true,
          options: [],
          actions: [
            {
              key: 'add',
              name: '确认',
            },
          ],
        },
      ];
      this.formChange(this.formData[1]);
    },
    async getAccountList(params) {
      this.noAccountText = '';
      const res = await getAccountList(params);
      const list = res.data || [];
      if (params.account_id) {
        this.accounts = list;
      } else {
        this.accountList = list;
        this.$set(
          this.formData[2],
          'options',
          formatMap(list, 'account_id', 'display_name'),
        );
      }
      if (!list.length) {
        this.noAccountText = '无匹配账号';
      }
    },
    async doApply() {
      let val = this.$refs.form.getValue();
      delete val.auth_ids;
      let target_ids = [];
      this.accounts.forEach((item) => {
        target_ids.push(item.account_id);
      });
      let message = '';
      if (!val.app_id) {
        message = '请选择应用';
      }
      if (!message && !target_ids.length) {
        message = '请添加授权账号';
      }
      if (message) {
        this.$message({
          message,
          type: 'error',
          showClose: true,
          duration: 3000,
        });
        return;
      }
      const res = await applyAuth({
        ...val,
        target_ids,
      });
      const msgType = (res && res.code === 200) ? 'success' : 'error';
      this.$message({
        message: res.message,
        type: msgType,
        showClose: true,
        duration: 3000,
      });
      this.addDialogShow = false;
      this.params.page = 1;
      this.getList();
    },
    async doCancel() {
      const res = await cancelAuth({
        app_id: this.curItem.app_id,
        auth_type: this.curItem.auth_type,
        target_ids: [this.curItem.target_id],
      }).finally(() => {
        this.cancelDialogShow = false;
      });
      const msgType = (res && res.code === 200) ? 'success' : 'error';
      this.$message({
        message: res.message,
        type: msgType,
        showClose: true,
        duration: 3000,
      });
      this.getList();
    },
    changeHandle(item) {
      this.doSearch({
        ...this.params,
        [item.key]: item.value,
      });
    },
    doSearch(val) {
      this.params = {
        ...val,
        page: 1,
        page_size: this.params.page_size,
      };
      this.getList();
    },
    formChange(item) {
      if (item.key === 'app_id') {
        // 清空账号类型选项
        let index = this.formData.findIndex((x) => x.key === 'auth_type');
        this.$set(this.formData[index], 'value', '');

        let opt = item.options.find((x) => x.key === item.value);
        // 应用权限包含agent、sub_agent，「账号类型」禁用广告主
        if (['agent', 'sub_agent'].some((x) => opt.scopes.includes(x))) {
          this.formData[index].options.forEach((x) => {
            if (['0'].includes(x.key)) {
              this.$set(x, 'disabled', true);
            }
          });
        } else {
          this.formData[index].options.forEach((x) => {
            this.$set(x, 'disabled', false);
          });
        }
      }

      if (item.key === 'auth_type') {
        let value = Number(item.value);
        if (value === 0) {
          this.$delete(this.formData[2], 'type');
          this.$set(
            this.formData[2],
            'placeholder',
            '输入ADV广告主ID、多个ID用英文“，”分开',
          );
          this.$set(this.formData[2], 'value', '');
        } else {
          this.getAccountList({
            account_type: Number(item.value),
          });
          this.$set(this.formData[2], 'placeholder', '请选择授权账户');
          this.$set(this.formData[2], 'type', 'select');
          this.$set(this.formData[2], 'value', []);
        }
        this.accounts = [];
      }
    },
    actionClick(item, btn) {
      // 1000004,1000020,1000021,1000031,1000032,1000060,1000064,1500343,1652203,1725015,1725016,1725017,1725018,1725019
      let val = this.$refs.form.getValue();
      console.log('val>>>>', val);
      let authType = Number(val.auth_type);
      if (item.type === 'select') {
        let accounts = [];
        const value = item.value;
        this.accountList.forEach((a) => {
          if (value.indexOf(a.account_id) > -1) {
            accounts.push(a);
          }
        });
        this.accounts = accounts;
      } else {
        this.getAccountList({
          account_type: authType,
          account_id: item.value,
        });
      }
      const config = {
        0: {
          title: {
            key: 'user_name',
            label: '广告主账户名',
          },
          info: [
            {
              key: 'account_id',
              label: '广告主ID',
            },
            {
              key: 'display_name',
              label: '广告主名称',
            },
            {
              key: 'company',
              label: '广告主公司名',
            },
          ],
        },
        1: {
          title: {
            key: 'user_name',
            label: '代理商名称',
          },
          info: [
            {
              key: 'account_id',
              label: '代理商ID',
            },
            {
              key: 'display_name',
              label: '代理商账户名',
            },
            {
              key: 'company',
              label: '代理商公司名',
            },
          ],
        },
        6: {
          title: {
            key: 'user_name',
            label: '子管理名称',
          },
          info: [
            {
              key: 'account_id',
              label: '子管理ID',
            },
            {
              key: 'display_name',
              label: '子管理账户名',
            },
            {
              key: 'company',
              label: '子管理公司名',
            },
          ],
        },
        2: {
          title: {
            key: 'user_name',
            label: '管家用户名',
          },
          info: [
            {
              key: 'account_id',
              label: '管家账户ID',
            },
            {
              key: 'user_id',
              label: '管家用户ID',
            },
            {
              key: 'display_name',
              label: '管家公司名',
            },
          ],
        },
      };
      this.accountConfig = config[authType];
    },
    linkClickHandle(col, row) {
      const key = col.key;
      if (key === 'target_id') {
        this.curItem = row;
        this.secretShow = false;
        this.accessShow = false;
        this.refreshShow = false;
        this.infoDialogShow = true;
      } else if (key === 'verify_url') {
        this.$copyText(row[key]).then(
          (e) => {
            this.$message.success('已复制到粘贴板');
          },
          (e) => {
            this.$message.error('当前浏览器不支持复制');
          },
        );
      }
    },
    actionClickHandle(brn, row) {
      this.curItem = row;
      this.cancelDialogShow = true;
    },
    pageChangeHandle(page) {
      this.params.page = page;
      this.getList();
    },
    pageSizeChangeHandle(size) {
      this.params.page_size = size;
      this.params.page = 1;
      this.getList();
    },
    add() {
      this.getAppList();
      this.accounts = [];
      this.addDialogShow = true;
    },
    async doAdd() {
      // this.doApply();
      if (this.addSubmitLoading) return;

      this.addSubmitLoading = true;
      try {
        await this.doApply();
      } finally {
        this.addSubmitLoading = false;
      }
    },
    cancelAuth() {
      this.doCancel();
    },
  },
};
</script>

<style lang="scss" scoped>
.mod-account-access {
  height: 100%;
  padding: 40px 74px;
  box-sizing: border-box;
  overflow-y: auto;
  .title-page {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    .text-title {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
    }
    .item-btn {
      width: 130px;
      height: 40px;
      line-height: 40px;
      background: $primary-color;
      box-shadow: 0px 2px 4px 0px rgba(0, 94, 181, 0.19);
      border-radius: 4px;
      text-align: center;
      font-size: 14px;
      font-family: NotoSansHans-Bold, NotoSansHans;
      font-weight: bold;
      color: #fff;
    }
  }
  .dialog-right {
    .add-content-box {
      padding: 14px 10px;
      .account-box {
        display: flex;
        .form-label {
          display: inline-block;
          width: 90px;
          height: 40px;
          text-align: right;
          line-height: 40px;
        }
        .no-account-text {
          height: 40px;
          line-height: 40px;
          color: #f56c6c;
        }
        .account-items {
          .account-item {
            margin-bottom: 10px;
            width: 414px;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            line-height: 40px;
            .account-title {
              padding: 0 15px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-size: 14px;
              font-weight: 500;
              color: #606266;
              background: #fafafa;
              border-top-left-radius: 4px;
              border-top-right-radius: 4px;
              border-bottom: 1px solid #dcdfe6;
            }
            .account-info {
              padding: 0 15px;
              font-size: 12px;
              font-weight: 400;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #606266;
            }
          }
        }
      }
    }
    .app-items {
      padding: 0 22px;
      .app-item {
        display: flex;
        align-items: flex-start;
        padding: 11px 0;
        border-bottom: 1px solid #f2f2f2;
        font-size: 14px;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
        .app-label {
          flex-shrink: 0;
          display: inline-block;
          width: 110px;
          color: #666666;
          .app-label-tip {
            padding-top: 6px;
            font-size: 12px;
            font-weight: bolder;
            .active {
              color: $primary-color;
            }
          }
        }
        .app-value {
          flex-grow: 1;
          color: #333333;
        }
        .btn-item {
          flex-shrink: 0;
          margin-left: 13px;
          font-size: 12px;
          font-weight: 500;
          color: $primary-color;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
  .dialog-confirm {
    .confirm-content {
      padding-top: 107px;
      padding-bottom: 30px;
      background-image: url('~@/assets/image/icon_alert.png');
      background-size: 72px;
      background-position: center 15px;
      background-repeat: no-repeat;
      text-align: center;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }
}
</style>